/**
 * Abrir un PDF en una pestaña nueva y en la página citada (paso 92b, D1).
 *
 * El fichero viene por `fetch` con el token (como `AuthedImage`: el token
 * nunca va en la URL, acabaría en el historial y en los logs del proxy), así
 * que lo que se abre es un `blob:` con `#page=N`, que entienden los visores
 * de Chrome, Edge, Firefox y Safari.
 *
 * ⚠️ La pestaña se abre ANTES de pedir el fichero, en el mismo clic: un
 * `window.open` después de un `await` lo bloquea el navegador como ventana
 * emergente. Si la descarga falla, se cierra y el error sube.
 */
export async function abrirPdfEnPagina(obtener: () => Promise<Blob>, pagina?: number): Promise<void> {
  const w = window.open('', '_blank');
  if (w) w.opener = null;
  try {
    const url = URL.createObjectURL(await obtener());
    const destino = pagina ? `${url}#page=${pagina}` : url;
    if (w) w.location.href = destino;
    else window.location.href = destino;
    // El visor ya tiene el fichero cargado; la URL se suelta al rato.
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (e) {
    w?.close();
    throw e;
  }
}
